export function formatNumber(number, countryCode, formType) {
  if (number === undefined || number === null) return "";
  let whole, decimal, remainder, result, increase;
  const thousandSeparator =
    countryCode === "uk" || countryCode === "au" ? "," : ".";
  const decimalSeparator =
    countryCode === "uk" || countryCode === "au" ? "." : ",";
  number = number.toString();
  if (number === "") return number;
  [whole, decimal] = number.split(".");
  if (decimal?.length >= 3 && decimal[2] >= 5) {
    increase =
      decimal[0] === "0"
        ? parseInt(decimal.substring(1, 2))
        : parseInt(decimal.substring(0, 2));
    increase += 1;
    increase = increase.toString();
    decimal = increase.length === 1 ? "0" + increase : increase;
  }
  const requiresTwoDecimals =
    formType === "upcare" ||
    formType === "leaseplus" ||
    formType === "flexpro" ||
    formType === "construction";
  if (requiresTwoDecimals) {
    decimal = decimal === undefined ? "00" : (decimal + "00").substring(0, 2);
  } else {
    decimal = decimal === undefined ? "00" : decimal.substring(0, 2);
  }
  if (whole.length <= 3) return whole + decimalSeparator + decimal;
  remainder = whole.length % 3;
  result = remainder ? [whole.slice(0, remainder)] : [];

  for (let index = remainder; index <= whole.length - 3; index += 3) {
    result.push(whole.slice(index, index + 3));
  }
  return result.join(thousandSeparator) + decimalSeparator + decimal;
}
export function formatNumberForPdf(number, lang, formType) {
  const wholeNumberCountries = { se: "se", no: "no", dk: "dk" };
  const isWholeNumberCountry = wholeNumberCountries[lang];
  const numStr = number.toString();
  let [whole, decimal] = numStr.split(".");

  const isNeedSpaceFormatting = whole.length >= 4 && whole.length <= 6;
  if (isNeedSpaceFormatting) {
    const spaceAt = whole.length - 3; // ex: 4 digits have one space (1 000), 5 digits have two spaces (10 000)
    whole = whole.slice(0, spaceAt) + " " + whole.slice(spaceAt);
  }

  if (isWholeNumberCountry) return whole;
  const decimalSeparator = lang === "uk" || lang === "au" ? "." : ",";
  const requiresTwoDecimals =
    formType === "upcare" ||
    formType === "flexpro" ||
    formType === "leaseplus" ||
    formType === "construction";
  const decimalPart = requiresTwoDecimals
    ? decimal === undefined
      ? "00"
      : (decimal + "00").substring(0, 2)
    : decimal || "0";

  if (!requiresTwoDecimals && (decimalPart === "00" || decimalPart === "0")) {
    return whole;
  }

  return `${whole}${decimalSeparator}${decimalPart}`;
}

export function roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee, form) {
  const isCountryRoundedToWhole = { se: true, no: true, dk: true };

  if (lang === "se" && form === "construction") {
    return Math.ceil(totalMonthlyFee / 5) * 5;
  }

  if (isCountryRoundedToWhole[lang]) {
    return Math.round(totalMonthlyFee);
  } else {
    return Math.round(totalMonthlyFee * 100) / 100;
  }
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + "...";
}

export function capitalizeFirstLetter(value) {
  const lowerCased = String(value).toLowerCase();
  return lowerCased.replace(/(^|\s)\S/g, (char) => char.toUpperCase());
}
export function generateRandomContractNumber() {
  return Math.floor(Math.random() * 9000) + 1000;
}

export function getTodaysDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const day = today.getDate().toString().padStart(2, "0");
  const date = `${year}-${month}-${day}`;
  return date;
}
export function splitAddress(address) {
  const parts = address.trim().split(" ");

  // Check if the last part is a number (house number)
  const lastPart = parts[parts.length - 1];
  const houseNumber = !isNaN(lastPart) ? parts.pop() : parts.shift();

  const street = parts.join(" ");

  return {
    street,
    houseNumber,
  };
}

export function dateToString(date) {
  if (!date) {
    return "";
  }
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() < 9 ? "0" : "") +
    (date.getMonth() + 1) +
    "-" +
    (date.getDate() < 10 ? "0" : "") +
    date.getDate()
  );
}

export function appendDictToFormData(formData, dict, formType, newDealer) {
  let all = [
    "name",
    "serial",
    "monthly",
    "price",
    "totalMonthlyFee",
    "dealerName",
    "dealerEmail",
    "quantity",
    "contractLength",
    "lifeOffer",
    "productCondition",
    "repurchase",
    "repurchaseKey",
    "deliveryDate",
    "customer",
    "currency",
    "AccessoriesQuantity",
  ];
  let leaseplus = [
    "socialSecurityNumber",
    "dateOfBirth",
    "customerName",
    "customerEmail",
    "customerPhone",
    "customerAddress",
    "customerZipCode",
    "customerCity",
    "customerNumber",
    "customContractNumber",
    "contractNumber",
    "sellerName",
    "purchasePrice",
    "installation",
    "residualPrice",
    "accessory",
    "purchasePriceAccessory",
    "residualPriceAccessory",
    "customerFirstName",
    "customerLastName",
    "customerStreet",
    "customerHouseNumber",
    "apiError",
    "extraInfo",
    "hasCampaignProducts",
  ];
  let flexPro = [
    "customerName",
    "address",
    "city",
    "zipCode",
    "companyNumber",
    "customerEmail",
    "customerInvoiceEmail",
    "companyTypeKey",
    "companyType",
    "companyTypeEn",
    "nameSignatory",
    "emailSignatory",
    "phoneSignatory",
    "dateOfBirthCustomerSignatory",
    "socialSecurityNumberCustomerSignatory",
    "customerNumber",
    "sellerName",
    "price",
    "residual",
    "AccessoriesName",
    "AccessoriesPrice",
    "TotalAccessoriesPrice",
    "installation",
    "limitedCompanyChecked",
    "limitedCompanyNotChecked",
  ];
  let construction = [
    "customerName",
    "address",
    "city",
    "zipCode",
    "companyNumber",
    "customerEmail",
    "nameSignatory",
    "emailSignatory",
    "phoneSignatory",
    "dateOfBirthCustomerSignatory",
    "socialSecurityNumberCustomerSignatory",
    "price",
    "residual",
    "AccessoriesName",
    "AccessoriesPrice",
    "TotalAccessoriesPrice",
  ];
  let upcare = [
    "customerName",
    "address",
    "city",
    "zipCode",
    "companyNumber",
    "customerEmail",
    "customerInvoiceEmail",
    "customerGeneralContact",
    "companyTypeKey",
    "companyType",
    "companyTypeEn",
    "nameSignatory",
    "emailSignatory",
    "phoneSignatory",
    "dateOfBirthCustomerSignatory",
    "socialSecurityNumberCustomerSignatory",
    "customerNumber",
    "contractNumber",
    "sellerName",
    "purchasePrice",
    "installation",
    "residualPrice",
    "AccessoriesName",
    "AccessoriesPrice",
    "TotalAccessoriesPrice",
    "extraInfo",
    "apiError",
    "limitedCompanyChecked",
    "limitedCompanyNotChecked",
  ];
  let onboarding = [
    "newDealerName",
    "organizationNumber",
    "taxNumber",
    "husqvarnaNumber",
    "dealerAddress",
    "nd_zipCode",
    "nd_city",
    "invoiceEmail",
    "contactPerson",
    "emailContactPerson",
    "phoneContactPerson",
    "nameSignatoryNewDealer",
    "emailSignatoryNewDealer",
    "dateOfBirthSignatory",
    "socialSecurityNumberSignatory",
    "fcaNumber",
  ];
  let arrays = [
    "name",
    "serial",
    "purchasePrice",
    "installation",
    "price",
    "residualPrice",
    "residual",
    "deliveryDate",
    "nameSignatory",
    "emailSignatory",
    "phoneSignatory",
    "dateOfBirthCustomerSignatory",
    "socialSecurityNumberCustomerSignatory",
    "nameSignatoryNewDealer",
    "emailSignatoryNewDealer",
    "dateOfBirthSignatory",
    "socialSecurityNumberSignatory",
    "AccessoriesName",
    "AccessoriesPrice",
    "TotalAccessoriesPrice",
    "AccessoriesQuantity",
    "accessory",
    "purchasePriceAccessory",
    "residualPriceAccessory",
    "quantity",
  ];
  let standard = [
    "customerName",
    "companyNumber",
    "customerEmail",
    "nameSignatory",
    "emailSignatory",
    "phoneSignatory",
    "dateOfBirthCustomerSignatory",
    "socialSecurityNumberCustomerSignatory",
    "price",
    "residual",
    "AccessoriesName",
    "AccessoriesPrice",
    "TotalAccessoriesPrice",
  ];
  for (const [key, value] of Object.entries(dict)) {
    if (
      !(value instanceof Object) ||
      key === "accessory" ||
      key === "purchasePriceAccessory" ||
      key === "residualPriceAccessory"
    ) {
      if (
        all.includes(key) ||
        (formType === "flexpro" && flexPro.includes(key)) ||
        (formType === "construction" && construction.includes(key)) ||
        (formType === "leaseplus" && leaseplus.includes(key)) ||
        (formType === "upcare" && upcare.includes(key)) ||
        (formType === "standard" && standard.includes(key)) ||
        (newDealer && onboarding.includes(key))
      ) {
        if (arrays.includes(key)) {
          if (
            key === "accessory" ||
            key === "purchasePriceAccessory" ||
            key === "residualPriceAccessory"
          ) {
            if (formData[key] instanceof Object) {
              formData[key].push(value);
            } else {
              formData[key] = [value];
            }
          } else {
            if (formData[key] instanceof Object) {
              formData[key].push(value);
            } else {
              formData[key] = [value];
            }
          }
        } else {
          formData[key] = value;
        }
      }
    } else if (key === "serial") {
      if (formData.hasOwnProperty("serial")) {
        formData[key].push(value.length > 0 ? value[0] : "-");
      } else {
        formData[key] = [value.length > 0 ? value[0] : "-"];
      }
    } else if (value instanceof Date) {
      if (arrays.includes(key)) {
        if (formData[key] instanceof Object) {
          formData[key].push(dateToString(value));
        } else {
          formData[key] = [dateToString(value)];
        }
      } else {
        formData[key] = dateToString(value);
      }
    } else {
      if (
        key !== "labels" &&
        key !== "extraFiles" &&
        key !== "contractFile" &&
        key !== "creditFile"
      ) {
        appendDictToFormData(formData, value, formType, newDealer);
      }
    }
  }
  return formData;
}

export function customizeDataForOrderInfoExcel(
  customerInformation,
  formInformation,
  params,
  productsValues,
  state,
) {
  let total = 0;
  const names = [];

  for (const key in productsValues) {
    if (productsValues.hasOwnProperty(key)) {
      const product = productsValues[key];

      // Sum totalProductPrice if available
      if (product.hasOwnProperty("totalProductPrice")) {
        total += product.totalProductPrice;
      }

      // Collect product name if available
      if (
        product.hasOwnProperty("name") &&
        product.name &&
        product.hasOwnProperty("quantity")
      ) {
        names.push(product.quantity + " st" + product.name);
      }
    }
  }

  const now = new Date(); // Get the current date and time

  // Extract year, month, day, hours, and minutes
  const year = now.getFullYear(); // Get the full year (e.g., 2024)
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Get the month (0-11, add 1 to make it 1-12)
  const day = now.getDate().toString().padStart(2, "0"); // Get the day of the month (1-31)
  const hours = now.getHours().toString().padStart(2, "0"); // Get the current hour (0-23)
  const minutes = now.getMinutes().toString().padStart(2, "0"); // Get the current minutes (0-59)

  // Format the date and time
  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;

  console.log(formattedDateTime); // Output: "YYYY-MM-DD HH:MM", e.g., "2024-09-12 14:05"

  const namesString = names.join(", ");

  const calculateTotalPrice = (products) => {
    /* HÄR */
    let totalPrice = 0;
    Object.keys(products).forEach((key) => {
      totalPrice +=
        products[key].name !== null
          ? (products[key].purchasePrice + products[key].installation) *
            products[key].quantity
          : 0;
    });
    Object.keys(state.accessories || {}).forEach((key) => {
      totalPrice += state.accessories[key].TotalAccessoriesPrice || 0;
    });
    return totalPrice;
  };

  const calculateTotalResidualPrice = (products) => {
    /* HÄR */
    let totalPrice = 0;
    Object.keys(products).forEach((key) => {
      totalPrice +=
        products[key].name !== null
          ? products[key].residualPrice * products[key].quantity
          : 0;
    });
    return totalPrice;
  };

  const orderInfoExcel = [
    params.lang,
    params.formType,
    customerInformation.dealerName,
    customerInformation.customerName,
    formInformation.contractLength,
    total,
    formInformation.quoteChecked ? "Offert" : "Order",
    formInformation.ceoraCampaign ? "Ceora Kampanj" : "Ingen Kampanj",
    namesString,
    formattedDateTime,
    customerInformation.companyNumber,
    formatNumber(calculateTotalPrice(productsValues)), //total product price
    formatNumber(calculateTotalResidualPrice(productsValues)), //total residual value
  ];
  // console.log(
  //   "1",
  //   customerInformation,
  //   2,
  //   formInformation,
  //   3,
  //   params,
  //   4,
  //   productsValues,
  // );
  // console.log("state", state);
  // console.log("calcucate", calculateTotalResidualPrice(productsValues));
  // console.log("orderInfoExcel", orderInfoExcel);

  return orderInfoExcel;
}

export function customizeDataForOnboarding(data, countryCode) {
  const orderMapping = {
    general: [
      "newDealerName",
      "taxNumber",
      "organizationNumber",
      "husqvarnaNumber",
      "dealerAddress",
      "nd_zipCode",
      "nd_city",
      "invoiceEmail",
      "contactPerson",
      "emailContactPerson",
      "phoneContactPerson",
    ],
    uk: [
      "newDealerName",
      "taxNumber",
      "organizationNumber",
      "husqvarnaNumber",
      "fcaNumber",
      "dealerAddress",
      "nd_zipCode",
      "nd_city",
      "invoiceEmail",
      "contactPerson",
      "emailContactPerson",
      "phoneContactPerson",
    ],
    no: [
      "newDealerName",
      "organizationNumber",
      "husqvarnaNumber",
      "dealerAddress",
      "nd_zipCode",
      "nd_city",
      "invoiceEmail",
      "contactPerson",
      "emailContactPerson",
      "phoneContactPerson",
    ],
  };
  let order;
  if (countryCode === "uk") {
    order = orderMapping["uk"];
  } else if (countryCode === "no") {
    order = orderMapping["no"];
  } else {
    order = orderMapping["general"];
  }

  let rowData = order.map((key) => data[key]);

  const socialSecurityNumberCountries = ["se", "dk", "no", "fi"];
  Object.keys(data.newDealerSignatories).forEach((id) => {
    rowData.push(data.newDealerSignatories[id].nameSignatoryNewDealer);
    if (socialSecurityNumberCountries.includes(countryCode)) {
      rowData.push(data.newDealerSignatories[id].socialSecurityNumberSignatory);
    } else {
      let date = dateToString(
        data.newDealerSignatories[id].dateOfBirthSignatory,
      );
      rowData.push(date);
    }
    rowData.push(data.newDealerSignatories[id].emailSignatoryNewDealer);
  });
  return rowData;
}

export function downloadPDF(blob, fileName) {
  const downloadUrl = window.URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = downloadUrl;
  downloadLink.download = fileName;
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);

  downloadLink.click();
  setTimeout(() => {
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(downloadUrl);
  }, 100);
}

export const downloadQuotePDF = (pdfBytes, fileName) => {
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
